import React, { useCallback, useState } from 'react'
// importo auth de mi archivo de firebase
import { auth } from '../firebase'
// importo para poder redirigirme a otra ruta --> hacer push a otras rutas
// withRouter -> nos permite empujar al usuario a diferentes rutas
// para que withRouter ---> funciona unicamente envolviendo en el export el withRouter(Login)
import { withRouter } from 'react-router-dom'



// withRouter ---> uiliza props para poer hacer una redirecion de mi history
const Reset = (props) => {

    // creo el state para mi email ---> para relacionarlo al input se hace con el onChange()
    const [email, setEmail] = useState('')
    // creamos un estado para pintar los errores
    const [error, setError] = useState(null)


    // funcion para poder manipular los datos de mi input
    // recibe un evento (e)
    const procesarDatos = (e) => {

        // para que no haga el metodo de get automatico
        e.preventDefault()

        // vamos a validar el email
        // si lo contrario de email, lo limpiamos
        if (!email.trim()) {
            // si eso no tiene nada escrito
            // console.log('Ingrese Email');
            // seteo el error
            setError('Datos vacíos email!')
            // coloco el return para que se salga de esta funcion
            return
        }

        // Limpio todos los errores
        setError(null)

        recuperar()

    }

    // creo un useCallback
    const recuperar = useCallback(async () => {
        try {

            // espero a la funcion
            // importo la funcion de auth para poder usar sus metodos
            await auth.sendPasswordResetEmail(email)
            console.log('Correo enviado')

            // redirecciono a mi usuario al login
            props.history.push('/login')

        } catch (error) {
            console.log(error)
            // guardo el mensaje en el estado
            setError(error.messsage)
        }
    },
        // para que se ejecute una sola vez
        [email, props.history])





    return (
        // margin top de 5
        <div className="mt-5">
            {/* Titulo */}
            <h3 className="text-center">
                Reiniciar contraseña
            </h3>
            <hr />
            {/* sistema de columnas y todo centrado */}
            <div className="row justify-content-center">
                {/* centrar el contenido, y que este todo en forma responsiva */}
                <div className="col-12 col-sm-8 col-md-6 col-xl-4">
                    {/* creamos el fomrulario */}
                    <form
                        // validaciones
                        // me invento una funcion llamada---> procesarDatos
                        onSubmit={procesarDatos}
                    >

                        {/* Pintamos todos los errores en caso de que existan */}
                        {
                            // si existe algo en el error
                            error && (
                                // creo el mensaje de error
                                <div className="div alert alert-danger">
                                    {/* pinto el error */}
                                    {error}
                                </div>
                            )
                        }

                        {/* creo un input */}
                        <input
                            // tipo
                            type="email"
                            // sus clases
                            className="form-control mb-2"
                            // nombre que va a tener la caja
                            placeholder="Ingrese Email"
                            // relaciono el input con el estado
                            onChange={(e) => setEmail(e.target.value)}
                            // coloco el value para poder limpiar los campos
                            value={email}
                        />
                        <hr />
                        {/* creo un boton */}
                        <button
                            className="btn btn-lg btn-dark btn-block"
                            // accionador de mi furmulario ---> por eso es de tipo submit
                            // es el que nos ejecuta el metodo de procesar datos
                            type="submit"
                        >
                            Reiniciar contraseña
                        </button>

                    </form>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Reset)